// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jlB0","comment":"styles_comment__kt6DM"};